import EventEmitter from "./EventEmitter";
import DrawingLogic from "./DrawingLogic";
// import * as Papa from "papaparse";
import Utils from "./Utils";
import simplify from "simplify-js";

export default class InteractiveImage extends EventEmitter {
  constructor(canvas = null, data = null) {
    super();
    this.LINES_RECORDER_FOR_INTRO = [];
    if (canvas && data) {
      this.canvas = canvas;
      this.data = data;
      this._state = "magic";
      this.MAGIC_COUNT = 0;
      this.SUPER_HELPER = false;
      this.MAGIC_ACTIVATION_LIMIT = 5;
      this.canvas.width = this.width = 512;
      this.canvas.height = this.height = 512;
      this.ctx = this.canvas.getContext("2d");
      // Sometimes (e.g. on mobile and smaller screens) the canvas is not 512px, let's update it.
      this.canvas.width = this.width = this.canvas.clientWidth;
      this.canvas.height = this.height = this.canvas.clientHeight;
      this.DRAWING = new DrawingLogic(this.canvas);
      // SET SCALE FOR RESIZE
      this.DRAWING.SCALE = this.canvas.clientWidth / 512;
      this.initListeners();
      if (canvas && data) this.loadNewData(true);
      this.draw();
    }
  }

  set state(val) {
    this._state = val;
    // reset points when changing state
    this.activePoint = [];
    // cancel resetting state
    this.DRAWING.IS_RESETTING = false;
  }
  get state() {
    return this._state;
  }

  initListeners() {
    //
    this.handler = {
      down: this.onDown.bind(this),
      move: this.onMove.bind(this),
      up: this.onUp.bind(this),
      keydown: this.onKeyDown.bind(this),
      segmentReady: this.onSegmentReady.bind(this),
      contextMenu: this.onContextMenu.bind(this),
    };
    this.canvas.addEventListener("mousedown", this.handler.down);
    this.canvas.addEventListener("touchstart", this.handler.down);
    this.canvas.addEventListener("mousemove", this.handler.move);
    this.canvas.addEventListener("touchmove", this.handler.move);
    this.canvas.addEventListener("mouseup", this.handler.up);
    this.canvas.addEventListener("touchend", this.handler.up);
    this.canvas.addEventListener("mouseout", this.handler.up);
    this.canvas.addEventListener("contextmenu", this.handler.contextMenu);

    document.addEventListener("keydown", this.handler.keydown);
    this.DRAWING.animator.addEventListener(
      "segmentReady",
      this.handler.segmentReady
    );
  }

  onDown(e) {
    e.preventDefault();
    this.DRAWING.down();
    this.isDrawing = true;
    let event = e;
    // if it's a touch event
    if (e.touches) {
      event = e.touches[0];
      const targetPos = e.touches[0].target.getBoundingClientRect();
      const offsetX = targetPos.left;
      const offsetY = targetPos.top;
      event.offsetX = event.clientX - offsetX;
      event.offsetY = event.clientY - offsetY;
      this.activePoint = [{ x: event.offsetX, y: event.offsetY }];
    } else this.activePoint = [{ x: event.layerX, y: event.layerY }];
  }
  onMove(e) {
    e.preventDefault();
    if (this.isDrawing) {
      let event = e;
      // if it's a touch event
      if (e.touches) {
        event = e.touches[0];
        // we shouldn't do this every time...
        const targetPos = e.touches[0].target.getBoundingClientRect();
        const offsetX = targetPos.left;
        const offsetY = targetPos.top;
        event.offsetX = event.clientX - offsetX;
        event.offsetY = event.clientY - offsetY;
        this.activePoint.push({ x: event.offsetX, y: event.offsetY });
      } else {
        this.activePoint.push({ x: event.layerX, y: event.layerY });
      }
      if (this.state == "pen") {
        this.DRAWING.drawLine(this.activePoint, this.DRAWING.color, this.ctx);
        this.DRAWING.print(this.ctx);
      }
      if (this.state == "eraser") {
        this.DRAWING.erase(this.activePoint, "white", this.ctx);
        this.DRAWING.print(this.ctx);
      }
    }
  }
  onUp(e) {
    e.preventDefault();
    if (this.activePoint)
      this.LINES_RECORDER_FOR_INTRO.push(simplify(this.activePoint, 1));

    this.prevIndexToDelete = 0;
    if (this.isDrawing && this.state == "magic") {
      this.MAGIC_COUNT++;
      this.raiseEvent("hasdrawnmagic", []);
      /**
       * FUNCTION TO ACTIVATE THE AUTOMATED CONCLUSION FOR THE DRAWING
       */
      if (
        this.SUPER_HELPER &&
        this.MAGIC_COUNT >= this.MAGIC_ACTIVATION_LIMIT &&
        !this.SUPER_HELPER_USED
      ) {
        this.DRAWING.animator.AUTOMATED_EXTRA_STEPS = this.DRAWING.length - 1;
        this.DRAWING.animator.DEFAULT_SPEED = 20;
        this.SUPER_HELPER_USED = true;
      } else if (this.SUPER_HELPER_USED) {
        this.DRAWING.animator.reset();
      }
      /**
       *
       */
      this.DRAWING.simplifyPoints = this.activePoint; //simplify(this.activePoint, 0);
    }
    if (this.isDrawing && this.state == "pen") {
      this.raiseEvent("hasdrawnpen", []);
    }
    this.isDrawing = false;
  }

  onContextMenu(e) {
    e.preventDefault();
    return false;
  }
  onKeyDown(e) {
    // console.log(e.keyCode);
    if (e.keyCode == 32) this.debug = !this.debug;
    if (e.key == "s")
      Utils.save(
        JSON.stringify(this.LINES_RECORDER_FOR_INTRO),
        "lines.json",
        "application/json"
      );
  }
  onSegmentReady(index) {
    // console.log(index);
    if (index == "end") {
      this.activePoint = [];
    } else {
      const indexToDelete = index - this.prevIndexToDelete;
      this.activePoint.splice(0, indexToDelete);
      this.prevIndexToDelete = index;
    }
  }
  onResize() {
    // console.log(this.width, this.canvas.clientWidth);
    let updateLinesScale = false;
    if (this.width != this.canvas.clientWidth) {
      updateLinesScale = true;
    }
    this.canvas.width = this.width = this.canvas.clientWidth;
    this.canvas.height = this.height = this.canvas.clientHeight;
    this.DRAWING.SCALE = this.canvas.clientWidth / 512;
    this.DRAWING.onResize(
      { width: this.width, height: this.height },
      updateLinesScale
    );
  }
  //
  async loadNewData(first = true) {
    // FORCE INTRO IMAGE
    // this.url = `${GLOBAL_PATH}drawing/22835670`;
    this.url = `${GLOBAL_PATH}drawing/${
      this.data[Math.floor(Math.random() * this.data.length)][0]
    }`;
    this.activeLines = await Utils.load(this.url);
    this.DRAWING.lines = this.activeLines;
    console.log("::: LINES READY :::");
    // console.log(this.DRAWING.lines);
    console.log("first val", first);
    this.raiseEvent("newdataloaded", []);
    if (!first) this.raiseEvent("imageready", []);
  }

  setDataForIntro(lines, speed) {
    this.DRAWING.lines = lines;
    this.DRAWING.drawWithThicknessByStep(
      this.DRAWING.memory,
      0,
      lines.length,
      this.DRAWING.SCALE,
      speed
    );
  }
  resetDataAfterIntro() {
    console.log("RESET DATA AFTER INTRO");
    this.DRAWING.savedSegment = null; // [];
    // this.DRAWING.memory.fillStyle = "white";
    // this.DRAWING.memory.fillRect(0, 0, this.width, this.height);
    this.DRAWING.lines = this.activeLines;
  }

  reset(reload = false) {
    this.DRAWING.reset(reload);
    this.MAGIC_COUNT = 0;
    this.SUPER_HELPER_USED = false;
    this.activePoint = null;
    this.ctx.fillStyle = "white";
    this.ctx.fillRect(0, 0, this.width, this.height);
    if (reload) this.loadNewData(false);
  }
  draw() {
    // clear
    if (this.DRAWING.DATA) {
      // console.log("HAS DATA LEFT");
      this.ctx.putImageData(this.DRAWING.DATA, 0, 0);
    } else {
      this.ctx.fillStyle = "white";
      this.ctx.fillRect(0, 0, this.width, this.height);
    }

    // DRAW THE USER LINE
    if (this.activePoint && this.state == "magic") {
      this.ctx.strokeStyle = this.DRAWING.BLUE; // "rgba(136,136,136,1)"; //"rgba(0,0,0,0.2)";
      this.ctx.lineCap = "round";
      this.ctx.lineWidth = 4 * this.DRAWING.SCALE;
      this.ctx.beginPath();
      this.activePoint.forEach((item, i) => {
        if (i == 0) {
          this.ctx.moveTo(item.x, item.y);
        } else {
          this.ctx.lineTo(item.x, item.y);
        }
      });
      this.ctx.stroke();
      this.ctx.closePath();
    }

    //
    this.DRAWING.update();
    this.DRAWING.draw();
    //
    if (this.debug) {
      this.DRAWING.debug();
    }
    requestAnimationFrame(this.draw.bind(this));
  }
}
